import { Box, Typography } from '@material-ui/core'
import React from 'react'
import DoneIcon from '@material-ui/icons/Done'

const list = [
  'Unlimited Number of Sessions',
  'Response Within 24 Hours',
  'Personalized Daily Workout Plan',
  '30 min Introductory Call',
]

export const CheckList = () => {

  return (
    <Box>
      {list.map(item => (
        <Box mb={1} display="flex" alignItems="flex-start" key={item}>
          <DoneIcon />
          <Box mr={1} />
          <Typography>
            {item}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

